import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";
import { LogOut, User } from "lucide-react";

const Header = () => {
  const { user, logout } = useAuth();
  const { lang, toggle, t } = useLang();
  const navigate = useNavigate();

  const navLinkCls = ({ isActive }) =>
    `font-display font-bold text-sm tracking-tight px-1.5 sm:px-2 py-1 ${isActive ? "border-b-2 border-black" : "text-[#4A4A4A] hover:text-black"}`;

  return (
    <header data-testid="app-header" className="sticky top-0 z-50 bg-white border-b border-black/100">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-10 h-16 flex items-center justify-between gap-1">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2 group flex-shrink-0">
          <div className="hidden sm:flex w-8 h-8 bg-black text-white items-center justify-center font-display font-black text-lg">€</div>
          <span className="font-display font-black tracking-tighter text-base sm:text-xl">{t.brand}</span>
          <span className="hidden md:inline overline text-[#737373] ml-2">/ resale value engine</span>
        </Link>

        <nav className="flex items-center gap-0.5 md:gap-4">
          <NavLink to="/valutazione" data-testid="nav-valuate" className={navLinkCls}>{t.nav.valuate}</NavLink>
          <NavLink to="/guide" data-testid="nav-guide" className={navLinkCls}>{t.nav.guide}</NavLink>
          {user && (
            <NavLink to="/cronologia" data-testid="nav-history" className={navLinkCls}>{t.nav.history}</NavLink>
          )}

          <button
            data-testid="lang-toggle"
            onClick={toggle}
            className="ml-0.5 sm:ml-2 whitespace-nowrap font-mono text-[10px] sm:text-xs font-bold tracking-widest border border-black px-1.5 py-1 hover:bg-black hover:text-white transition-colors"
          >
            {lang.toUpperCase()}/{lang === "it" ? "EN" : "IT"}
          </button>

          {user ? (
            <div className="flex items-center gap-2 ml-2">
              <span data-testid="user-name" className="hidden sm:flex items-center gap-1 text-sm font-medium">
                <User size={14} /> {user.name}
              </span>
              <button
                data-testid="logout-btn"
                onClick={() => { logout(); navigate("/"); }}
                className="flex items-center gap-1 font-display font-bold text-sm px-2 sm:px-3 py-2 sm:py-1 border border-black hover:bg-black hover:text-white transition-colors"
              >
                <LogOut size={14} /> <span className="hidden sm:inline">{t.nav.logout}</span>
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-0.5 sm:gap-2 ml-0.5 sm:ml-2">
              <Link data-testid="nav-login" to="/login" className="whitespace-nowrap font-display font-bold text-sm px-1 sm:px-3 py-2 sm:py-1 hover:underline">{t.nav.login}</Link>
              <Link data-testid="nav-signup" to="/signup" className="whitespace-nowrap font-display font-bold text-sm px-1.5 sm:px-3 py-2 sm:py-1 bg-black text-white hover:bg-[#002FA7] transition-colors">{t.nav.signup}</Link>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
